import './Responses.scss'
import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { opinionQuestions } from './../assess/question'

const Response = ({index, text, average}) => {
  return (
    <div className='Response'>
      <h4 className='Response_index'>{index}</h4>
      <p className='Response_text'>{text}</p>
      <div className='Response_avg'>
        <span>Average <span>response</span></span>
        <h5>{(Math.round(average * 10) / 10).toFixed(1)} / 10</h5>
      </div>
    </div>
  )
}

class Responses extends Component {

  render(){

    var questionData = {};
    for(var responseId in this.props.responses){
      var response = this.props.responses[responseId];
      response.surveyData.questions.forEach(q => {
        questionData[q.id] = questionData[q.id] || 0
        questionData[q.id] += q.value
      })
    }
    var numResponses = Object.keys(this.props.responses).length

    return (
      <div className="responses">
        {Object.keys(questionData).map(x =>
          <Response key={x} index={x} text={opinionQuestions[x - 1] ? opinionQuestions[x - 1].title : ""} average={questionData[x] / numResponses}/>
        )}
      </div>
    )
  }
}
export default observer(Responses)



// WEBPACK FOOTER //
// ./src/dash/Responses.js